export const shopWindowTypes = {
  METHOD: "method",
  LIST: "list",
  PRODUCT: "product",
  ASK: "ask",
  TEST: "test",
};

export const constants = {
  // Used for the prefix for the Messenger and ChildMessenger.
  MESSAGE_PREFIX: "_pixmoto_",
};

export const eventNames = {
  LINK: "link.open",

  SET_SHOP_WINDOW: "set.shopwindow",
  SHOP_WINDOW_DID_MOUNT: "shopwindow.mount",
  CTA_DATA_DID_UPDATE: "cta.data.update",
  SHOP_WINDOW_EXIT: "shopwindow.exit",
  SHARE_LINK: "link.share",

  DECREMENT_SHOP_WINDOW_INDEX: "shopwindow.decrement",
  INCREMENT_SHOP_WINDOW_INDEX: "shopwindow.increment",
  SHOP_WINDOW_INDEX_CHANGED: "shopwindow.changed",
  USER_INTERACTION_START: "user.interaction.start",
  USER_INTERACTION_END: "user.interation.end",
  ARTICLE_TRANSITION_START: "article.transition.start",
  ARTICLE_TRANSITION_END: "article.transition.end",
  ADD_FAVORITE: "favorite.add",
  UPDATE_FAVORITES: "favorite.update",
  SHOW_FAVORITES: "favorite.show",
  OPEN_SHOP_WINDOW: "shopwindow.open",
  CLOSE_SHOP_WINDOW: "shopwindow.close",
  DISMISS_FAVORITES: "favorite.dismiss",
  EXIT: "app.exit",
  PLAY: "video.play",
  VIDEO_POSITION: "video.position",
  VIDEO_MARKER_SELECTED: "video.marker.selected",
  VIDEO_MARKER_REACHED: "video.marker.reached",
  VIDEO_ENDED: "video:ended",
  TIME_SYNC: "timeline.sync",
  ACTION_SHEET_EXIT: "actionsheet.exit",
  CHAIN_ADVANCE: "chain:advance",
  PIXIE_RESUME: "pixie.resume",
};

export const valueNames = {
  SHOP_WINDOW_CONFIG: "value.shopwindow.config",
  SHOP_WINDOW_DEFAULT_CONFIG: "value.shopwindow.default.config",
  VIDEO_TIMELINE_NAME: "value.video.timeline.name",
  HAS_CONTROL_BAR: "value.has.controlbar",
  ORIENTATION: "value.orientation",
  SHOP_WINDOW_CONFIG_LIST: "value.list.shopwindow.config",
  ACTIVE_ARTICLE: "value.active.article",
  VIDEO_ENDED: "value.video.ended",
  // Whole seconds remaining until the video ends, or absent/null when
  // unknown. Drives the time-based chain reveal + countdown.
  VIDEO_REMAINING: "value.video.remaining",
  // Whether the video is actively playing. Published by VideoJs on play/pause so
  // the chain end-of-video countdown can freeze while the viewer pauses
  // instead of auto-advancing off a still-paused video. Absent = treated as
  // playing (fail-open, so an unknown state never wedges the countdown).
  VIDEO_PLAYING: "value.video.playing",
  // Set when advancing to a chain recommendation so the swapped-in
  // video continues playing (playlist-style) instead of waiting for a click,
  // even when the experience's own autoPlay default is off. Consumed + cleared
  // by VideoJs on the next load.
  CHAIN_AUTOPLAY: "value.chain.autoplay",
  // Latched true once the chain UI has revealed for the current experience (the
  // reveal window was reached, or the video ended). Stays true until the next
  // experience loads, so the chain doesn't disappear when the viewer scrubs back
  // out of the reveal window — the end-state is consistent once shown.
  CHAIN_REVEALED: "value.chain.revealed",
};
